import type { MsalAuthenticationResult } from '@azure/msal-react'
import type { FC } from 'react'

export const MsalErrorComponent: FC<MsalAuthenticationResult> = ({
  error,
}: MsalAuthenticationResult) => {
  return (
    <div className="text-sm font-bold">
      An Error Occurred:
      {error ? error.errorCode : 'unknown error'}
    </div>
  )
}
